import { createEffect, type Accessor, type Setter } from "solid-js"
import { dropDownOpenedEvent } from "./dropDownOpenedEvent"
import { emitEvent, mountListener } from "./event"

type DropDownRef = unknown

export default function closeDropDownWhenOtherDropDownOpens (
  ref : DropDownRef,
  isDropDownOpen: Accessor<boolean>,
  setIsDropDownOpen: Setter<boolean>) {
  mountListener(dropDownOpenedEvent, (otherDropDown: DropDownRef) => {
    if (otherDropDown !== ref) {
      setIsDropDownOpen(false)
    }
  })
  createEffect(() => {
    if (isDropDownOpen()) {
      emitEvent(dropDownOpenedEvent, ref)
    }
  })
}